import { FEATURE_KEYS } from '../../utils/featureFlagKeys'

export default {
  data() {
    return {
      featuresReady: false
    }
  },
  methods: {
    isFeatureOn(featureKey) {
      if (!this.$store.getters['growthbook/isGrowthBookInitialized']) {
        return false
      }

      if (!FEATURE_KEYS[featureKey]) {
        console.log(`Feature key "${featureKey}" not found in FEATURE_KEYS`)
        return false
      }

      const feature = this.$store.getters['growthbook/getFeature'](FEATURE_KEYS[featureKey])
      return feature ? feature.value === true : false
    }
  },
  async mounted() {
    // Wait until GrowthBook is initialized
    const store = this.$store
    while (!store.getters['growthbook/isGrowthBookInitialized']) {
      await new Promise(resolve => setTimeout(resolve, 50))
    }
    this.featuresReady = true
  }
}
